import { RagIndex } from '@/core/indexesEnum';
import { SourceDTO } from '@/dto/QuestionResponseDTO';

export class BaseMessage {
  dateTime?: Date;
  text: string;
  isBot: boolean;

  constructor(text: string, isBot: boolean) {
    this.dateTime = new Date();
    this.text = text;
    this.isBot = isBot;
  }
}

export class LegalAssistantMessage extends BaseMessage {
  sources?: SourceDTO[] | null;
  ragIndex?: RagIndex | null;

  constructor(
    text: string,
    isBot: boolean,
    sources: SourceDTO[] | null,
    ragIndex?: RagIndex | null
  ) {
    super(text, isBot);

    this.sources = sources;
    this.ragIndex = ragIndex;
  }
}

export class LegalAssistantSectionsMessage extends LegalAssistantMessage {
  sectionResponses?: Record<string, string>;
  sectionSources?: Record<string, SourceDTO[]>;
  defaultSection?: string;

  constructor(
    text: string,
    isBot: boolean,
    sources: SourceDTO[] | null,
    sectionResponses?: Record<string, string>,
    sectionSources?: Record<string, SourceDTO[]>
  ) {
    super(text, isBot, sources);

    if (isBot) {
      this.sectionResponses = sectionResponses;
      this.sectionSources = sectionSources;
    }
  }
}
